import Script from 'next/script'

const NaverPreLog = () => {
  return <Script id="네이버프리미엄로그" src="//wcs.naver.net/wcslog.js" />
}

export default NaverPreLog
